import React from 'react';
import { X } from 'lucide-react';

// Reusable in-app YouTube player modal. Accepts a youtube key or full url.
export default function VideoModal({ open, youtubeKey, title, onClose }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-5xl aspect-video bg-black rounded-lg overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 bg-black/70 hover:bg-black text-white rounded-full p-2 transition-colors"
          aria-label="Close"
        >
          <X size={22} />
        </button>
        {youtubeKey ? (
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/${youtubeKey}?autoplay=1&rel=0`}
            title={title || 'Player'}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-center px-6">
            <div className="w-16 h-16 border-4 border-[#e50914] border-t-transparent rounded-full animate-spin mb-4" />
            <p className="text-white/70">No trailer available for "{title}".</p>
          </div>
        )}
      </div>
    </div>
  );
}